/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {CreateMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const createMerchant = (request: CreateMerchantRequest, options?: CashRequestOptions) => post<CreateMerchantRequest, CreateMerchantResponse>("/2.0/cash/create-merchant", request, {...options, rejectOnError: true })